import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';

interface GeneralFormFieldsCancelAndConfirmSignature {
  Args: {
    cancel?: () => void;
    cancelText?: string;
    confirm?: () => void;
    confirmIcon?: IconName;
    confirmText?: string;
    hasNoCancelButton?: boolean;
    hasNoConfirmButton?: boolean;
    isCancelDisabled?: boolean;
    isConfirmDisabled?: boolean;
    isConfirmLoading?: boolean;
  };
}

// Remark for when this component is refactored due to the usage of Ember Paper:
// Do not forget to stop the propagation of the cancel/confirm actions when the buttons are disabled!
export default class GeneralFormFieldsCancelAndConfirm extends Component<GeneralFormFieldsCancelAndConfirmSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get cancelTextWithDefault() {
    return this.args.cancelText ?? this.intl.t('general.cancel');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get confirmTextWithDefault() {
    return this.args.confirmText ?? this.intl.t('general.apply');
  }

  <template>
    <div
      class="layout cancel-and-confirm-btns flex items-center justify-center"
    >
      {{#unless @hasNoCancelButton}}
        <PrismButton
          @buttonType="secondary"
          @isDisabled={{@isCancelDisabled}}
          @label={{this.cancelTextWithDefault}}
          @onClick={{@cancel}}
          data-test-id="cancel-button"
        />
      {{/unless}}
      {{#unless @hasNoConfirmButton}}
        <div class="ic-product-tour-confirm ml-300">
          <PrismButton
            @iconBefore={{@confirmIcon}}
            @isDisabled={{@isConfirmDisabled}}
            @isLoading={{@isConfirmLoading}}
            @label={{this.confirmTextWithDefault}}
            @onClick={{@confirm}}
            data-test-id="confirm-button"
          />
        </div>

      {{/unless}}
    </div>
  </template>
}
